import type { AppState } from "store/types";

export const getModalState = (state: AppState) => state.legacy.ui.modal;
